import { useProjectAccessCtx } from '../../features/projects/ProjectAccessContext';
import { hasPerm } from '../../features/projects/hooks/useProjectAccess';

export type ProjectNavItem = {
    key: string;
    label: string;
    to: string;
    end?: boolean;
    disabled?: boolean;
};

export function useProjectNavItems(projectId?: string): ProjectNavItem[] {
    const { access, isLoading: accessLoading } = useProjectAccessCtx();

    if (!projectId) return [];

    const canOpenSettings = !accessLoading && hasPerm(access?.permissions, 'project.settings.open');

    return [
        { key: 'dashboard', label: 'Dashboard', to: `/projects/${projectId}`, end: true },
        { key: 'contracts', label: 'Contracts', to: `/projects/${projectId}/contracts` },
        { key: 'wbs', label: 'WBS', to: `/projects/${projectId}/wbs` },
        { key: 's-curve', label: 'S-Curve', to: `/projects/${projectId}/s-curve` },
        { key: 'gantt', label: 'Gantt', to: `/projects/${projectId}/gantt` },
        { key: 'tasks', label: 'Tasks', to: `/projects/${projectId}/tasks` },
        { key: 'risks', label: 'Risks', to: `/projects/${projectId}/risks` },
        { key: 'settings', label: 'Settings', to: `/projects/${projectId}/settings`, disabled: !canOpenSettings },
    ];
}
